import styled from 'styled-components';
import { BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const Container = styled('div')`
	max-height: 110px;
	border-bottom: solid 1px ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 8)};
	padding: 10px 15px;
	font-size: 13px;
	overflow: auto;
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-content: flex-start;
`;

const Content = styled('div')`
	width: 150px;
	font-size: 13px;
	font-weight: 400;
	color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 75)};
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	margin: 10px 30px 10px 0;
`;

export { Container, Content };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/SharedDocuments/styles.ts